var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5879 13.856L28.7139 2H26.3139L17.5239 12.294L10.4999 2H2.3999L13.0199 17.568L2.3999 30H4.7999L14.0839 19.128L21.5019 30H29.6019L18.5879 13.856ZM15.3019 17.704L14.2259 16.154L5.6639 3.82H9.3499L16.2579 13.774L17.3339 15.324L26.3159 28.264H22.6299L15.3019 17.704Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cf3dee22327106d34158f5e06b32cceb.svg";
export { ForwardRef as ReactComponent };